<div class="terms" id="terms" fxLayout="column" fxLayoutGap="20px">
    <div class="logos" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
        <img id="logoDental" src="assets/images/horizontal_logo_lg.png" alt="Logotipo Dental" /> 
    </div>
        
    <h2>
        Política de privacidade Dental Office &nbsp;<br />
        Agendamento On-line
    </h2>
    
    <p>
        <span>
            Esta Política de Privacidade de Dados foi criada para reafirmar nosso compromisso 
            com a segurança, privacidade e a transparência no tratamento de dados pessoais e 
            informações sensíveis.
        </span>
    </p>
    <p>
        <span>
            Ao acessar e/ou utilizar a funcionalidade “Agendamento On-line” do nosso software 
            Dental Office, você expressa sua aceitação plena e sem reservas aos termos aqui constantes, 
            para todos os fins de direito.
        </span>
    </p>
    <p>
        <span>
            Se você não concordar com algum dos termos e regras aqui previstos, não deverá acessar 
            e/ou utilizar a funcionalidade Agendamento On-line.
        </span>
    </p>
    
    <p><strong>SOBRE A COLETA DE DADOS</strong></p>
    
    <p><span>Quando você faz um agendamento on-line, algumas informações são coletadas:</span></p>
    <ul>
        <li>
            <span>Informações pessoais fornecidas por você – Coletamos informações de nome e celular – 
                via preenchimento dos formulários em nosso software.
            </span>
        </li>
        <li>
            <span>
                Informações sobre o agendamento pretendido – Coletamos informações de nome da clínica, 
                tipo do agendamento, identificação do dentista, data e a hora selecionada – via 
                preenchimento dos formulários em nosso software.
            </span>
        </li>
    </ul>
    
    <p><strong>PARA QUAL FINALIDADE UTILIZAMOS OS DADOS PESSOAIS</strong></p>
    <p>
        <span>
            O presente termo permite que a Dental Office use suas informações pessoais para as 
            seguintes finalidades.
        </span>
    </p>
    <ol>
        <li>
            <span>
                Para enviar a clínica e/ou o cirurgião-dentista, a data e horário que escolheu para
                seu próximo atendimento.
            </span>
        </li>
        <li><span>Para personalizar a experiência do usuário.</span></li>
        <li>
            <span>
                Simplificar, facilitar e agilizar a comunicação entre pacientes e a clínica e/ou o 
                cirurgião-dentista que irá realizar o atendimento.
            </span>
        </li>
        <li>
            <span>
                Para entender como nossos usuários usam os serviços e recursos fornecidos em 
                nosso software.
            </span>
        </li>
        <li><span>Para melhorar nosso software.</span></li>
        <li><span>Para melhorar o atendimento ao cliente.</span></li>
        <li>
            <span>
                Ajudar a responder com mais eficácia às solicitações de atendimento ao cliente e 
                às necessidades de suporte.
            </span>
        </li>
    </ol>
    <p><strong>SOBRE O ACESSO ÀS SUAS INFORMAÇÕES PESSOAIS</strong></p>
    <p>
        <span>
            Apenas os usuários autorizados pela clínica e/ou cirurgião dentista, para qual 
            direcionou seu pedido de agendamento de consulta, terão acesso às suas informações pessoais.
        </span>
    </p>
    <p><strong>OBSERVÂNCIA À LGPD - LEI GERAL DE PROTEÇÃO A DADOS</strong></p>
    <p>
        <span>
            Para a Dental Office é de extrema importância garantirmos a proteção das informações que 
            nos são confiadas por nossos usuários. Na Dental Office, estamos comprometidos em manter 
            os mais altos padrões de privacidade e proteção de dados. Também acreditamos que é importante
                ser transparente no que diz respeito ao manuseio de informações e estamos comprometidos em 
                cumprir os requisitos da Lei 13.709/2018, comumente conhecida como Lei Geral de Proteção
            de Dados (LGPD), bem como o exercício de suas atividades e direitos sob eles.
        </span>
    </p>
    <p>
        <span>
            A Dental Office também se compromete a não vender, alugar ou repassar informações para terceiros. 
            A única exceção está em casos em que essas informações forem exigidas judicialmente.
        </span>
    </p>
    <p>
        <span>
            Se em algum momento for necessário usar as informações para outros fins que não os definidos 
            nesta Política de Privacidade, entraremos em contato com você solicitando sua autorização.
        </span>
    </p>
    <p><strong>PAPÉIS DE OPERADOR E CONTROLADOR DE DADOS</strong></p>
    <p>
        <span>
            Segundo a LGPD, a Dental Office tem um papel de Operador, pois armazena e trata dados pessoais 
            dos pacientes e usuários, a partir dos dados inseridos nos nossos Software pela clínica e/ou 
            o cirurgião-dentista, que neste caso tem o papel de Controlador.
        </span>
    </p>
    <p>
        <span>
            A clínica e/ou o cirurgião-dentista, segundo a LGPD, tem um papel de Controlador, pois obtém 
            os dados pessoais de seus pacientes, durante o atendimento e relacionamento que mantém para 
            exercer sua profissão ou a gestão de seus negócios.
        </span>
    </p>
    <p>
        <span>
            A Dental Office trata os dados pessoais, a partir do interesse da clínica e/ou o 
            cirurgião-dentista, para que executem suas atividades profissionais e de gestão, atuando, a 
            Dental Office, como Operador destes dados, autorizada pela clínica e/ou o cirurgião-dentista.
        </span>
    </p>
    <p><strong>ESCLARECIMENTO DE DÚVIDAS</strong></p>
    <p>
        <span>
            Qualquer dúvida em relação à nossa política de privacidade pode ser esclarecida entrando em 
            contato conosco.
        </span>
    </p>
    <p><span>Envie um email para rhsoftware@rhsoftware.com.br.</span></p>
    <p><span>Dental Office - Estrada de Santa Isabel, 1647 Cj 31 - Caputera - Arujá - SP 07434-100</span></p>
</div>